import React from "react"

import FieldSelect2 from "./Select2";

function FieldSelect2Multi(props) {
    return <FieldSelect2 {...props} isMulti={true}/>
}

export default FieldSelect2Multi
